/* eslint-disable react/prop-types */
import React from 'react';
import { Empty, Typography,  } from 'antd';

import styles from './EmptyState.less';

const { Text } = Typography;

/**
 * EmptyState —— 空态
 * 用于「本期不做」的区块（如看板里的待接入项）与真的无数据场景区分：
 *  - kind='pending'  灰色「本期不做」占位，保留结构，方便后续填内容
 *  - kind='empty' 常规无数据
 */
const EmptyState = (props) => {
  const {
    description = '暂无数据',
    hint,
    action,
    kind = 'empty',
    compact,
    className,
  } = props;

  return (
    <div
      className={`${styles.wrap} ${kind === 'pending' ? styles.pending : ''} ${
        compact ? styles.compact : ''
      } ${className || ''}`}
    >
      <Empty
        description={
          <div className={styles.desc}>
            <Text>{description}</Text>
            {hint && (
              <Text className={styles.hint} type="secondary">
                {hint}
              </Text>
            )}
          </div>
        }
      />
      {action && <div className={styles.action}>{action}</div>}
    </div>
  );
};

export default EmptyState;
